import { Users } from 'lucide-react'
import { ProgramInvites } from '@/components/settings/ProgramInvites'
import { motion } from 'framer-motion'
import { useTranslation } from '@/hooks/useTranslation'

const Members = () => {
	const { t } = useTranslation()
	return (
		<div className="p-4 md:p-8 max-w-5xl mx-auto space-y-6">
			<motion.div
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.3 }}
				className="bg-gradient-to-r from-slate-50 to-white dark:from-slate-900 dark:to-slate-800 rounded-xl p-6 shadow-sm border border-border/50 mb-6">
				<div className="flex items-center gap-3">
					<div className="p-2 bg-primary/10 rounded-lg">
						<Users className="h-5 w-5 text-primary" />
					</div>
					<div className="flex-1">
						<h1 className="text-xl md:text-2xl font-semibold text-foreground">
							{t('members.title')}
						</h1>
						<p className="text-sm text-muted-foreground mt-0.5">
							{t('members.description')}
						</p>
					</div>
				</div>
			</motion.div>

			<ProgramInvites />
		</div>
	)
}

export default Members